import { getText } from '../../utils';
var inlineCard = function inlineCard(node, schema) {
  var _node$attrs$data;
  return node.attrs.url || ((_node$attrs$data = node.attrs.data) === null || _node$attrs$data === void 0 ? void 0 : _node$attrs$data.url) || getText(node);
};
export default inlineCard;